import { Box, Heading } from '@chakra-ui/react';

import React from 'react';

const HorizontalText = () => (
  <Box
    display="flex"
    className="hor-text-wrapper"
  >
    <Heading
      as="h4"
      ml={4}
      size="3xl"
      className="hor-text"
    >

      Everything is 100% FREE. No Obligation to Accept.
    </Heading>
    <Heading
      ml={4}
      as="h4"
      size="3xl"
      className="hor-text"
    >

      Everything is 100% FREE. No Obligation to Accept.
    </Heading>
    <Heading
      ml={4}
      as="h4"
      size="3xl"
      className="hor-text"
    >

      Everything is 100% FREE. No Obligation to Accept.
    </Heading>
  </Box>
);

export default HorizontalText;
